import { Handshake, LineChart, Users, ArrowUpRight } from "lucide-react";
import { IMAGES } from "../../data/site";
import { useContent } from "../../i18n/content";
import { Reveal } from "../motion/Reveal";

const ICONS = { Handshake, LineChart, Users };

export const Investors = ({ onPartner }) => {
    const { ui, site } = useContent();
    return (
    <section id="investors" data-testid="investors-section" className="relative py-24 lg:py-32 overflow-hidden">
        <div className="absolute inset-0" aria-hidden="true">
            <img src={IMAGES.investors} alt="" className="w-full h-full object-cover opacity-15" loading="lazy" />
            <div className="absolute inset-0 bg-[#292a24]/70" />
        </div>

        <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
            <Reveal>
                <div className="flex items-center gap-4">
                    <span className="font-display text-xs tracking-[0.3em] text-[#a2a59d]/60">CH.09</span>
                    <span className="h-px w-10 bg-[#f6c422]/60" aria-hidden="true" />
                    <span className="overline-text">Investor Relations</span>
                </div>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight text-white mt-6 max-w-4xl leading-[1.05]">
                    Building Long-Term <span className="text-[#f6c422]">Infrastructure Value</span>
                </h2>
            </Reveal>
            <Reveal delay={0.2}>
                <p className="text-[#d8d9d2] text-base lg:text-lg mt-6 max-w-2xl leading-relaxed">
                    Sadja Core Corp welcomes partnerships with global institutions to transform
                    emerging market infrastructure.
                </p>
            </Reveal>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
                {site.investorCards.map((c, i) => {
                    const Icon = ICONS[c.icon];
                    return (
                        <Reveal key={c.num} delay={0.1 * i} className="h-full">
                            <div
                                data-testid={`investor-card-${c.num}`}
                                className="group h-full border border-[#4a4c42] bg-[#292a24]/80 backdrop-blur-md p-8 hover:border-[#f6c422]/70 transition-colors duration-500"
                            >
                                <div className="flex items-center justify-between mb-8">
                                    <Icon className="w-7 h-7 text-[#f6c422]" strokeWidth={1.5} />
                                    <span className="font-display text-xs text-[#a2a59d]/50 tracking-[0.2em]">{c.num}</span>
                                </div>
                                <h3 className="font-display text-lg font-extrabold uppercase tracking-[0.1em] text-white group-hover:text-[#f6c422] transition-colors duration-300">
                                    {c.title}
                                </h3>
                                <p className="text-sm text-[#a2a59d] mt-3 leading-relaxed">{c.desc}</p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>

            <Reveal delay={0.25}>
                <button
                    data-testid="investor-cta-discuss-partnership"
                    onClick={onPartner}
                    className="mt-12 inline-flex items-center gap-3 bg-[#f6c422] text-[#292a24] font-display font-bold text-xs tracking-[0.18em] uppercase px-8 py-4 hover:bg-[#ffe169] transition-colors duration-300 group"
                >
                    {ui.investors.cta}
                    <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
            </Reveal>
        </div>
    </section>
    );
};
